<template>
    <div id="app" :class="{ arabic: interfaceLanguage == 'ar' }">
        <app-header></app-header>
        <div class="container">
            <div class="row" v-if="showNav">
                <div class="col-xs-12">
                    <div class="vue-tabs stacked">
                        <div class="left-vertical-tabs">
                            <div class="nav-tabs-wrapper stacked">
                                <ul class="nav nav-pills nav-stacked">
                                    <li class="tab">
                                        <router-link to="/moje-konto">{{ $t('MY_ACCOUNT') }}</router-link>
                                    </li>
                                    <li class="tab">
                                        <router-link to="/wyniki-badan">
                                            {{ $t('MEDICAL_RESULTS') }}
                                            <span class="unreaded-length" v-if="unreadExaminationsNumber > 0">
                                                {{ unreadExaminationsNumber }}
                                            </span>
                                        </router-link>
                                    </li>
                                    <li class="tab" v-if="!accountTypeIsPro">
                                        <router-link to="/moje-dane">{{ $t('MY_MEDICAL_DATA') }}</router-link>
                                    </li>
                                    <li class="tab" v-if="!accountTypeIsPro">
                                        <router-link to="/moje-zakupy">{{ $t('MY_ORDERS') }}</router-link>
                                    </li>
                                    <li class="tab">
                                        <router-link to="/kody-aktywacyjne">{{ $t('ACTIVATION_CODES') }}</router-link>
                                    </li>
                                    <li class="tab">
                                        <router-link to="/ustawienia">{{ $t('SETTINGS') }}</router-link>
                                    </li>
                                    <li class="tab" v-if="isBuyForWoman">
                                        <a @click="activateBuyForWomanAccount" style="cursor: pointer">
                                            {{ $t('ACTIVATE_ACCOUNT') }}
                                        </a>
                                    </li>
                                    <li class="tab tab--last">
                                        <a @click="openDictionary" class="tab--last--href" style="cursor: pointer">
                                            <p style="text-align:center;width:100%">
                                                {{ $t('DICTONARY_OF_CONCEPTS') }}
                                            </p>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="tab-content right-text-tabs">
                            <transition name="slide" mode="out-in">
                                <router-view name="componentsview"></router-view>
                            </transition>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12">
                    <div class="box-footer">
                        <router-view name="map"></router-view>
                    </div>
                </div>
            </div>
        </div>
        <transition name="slide" mode="out-in">
            <router-view></router-view>
        </transition>
        <router-view name="info" class="mt-5" v-if="!accountTypeIsPro"></router-view>
        <app-footer></app-footer>
        <div v-if="showLoadingSpinner" class="loading"></div>
    </div>
</template>

<script>
import Header from './components/shared/the-header.vue';
import Footer from './components/shared/footer/the-footer.vue';
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
    components: {
        appHeader: Header,
        appFooter: Footer,
    },
    computed: {
        ...mapState(['user', 'isUserLogged', 'interfaceLanguage']),
        ...mapGetters(['showLoadingSpinner', 'accountTypeIsPro', 'userShopUrl', 'survey', 'unreadExaminationsNumber']),
        isBuyForWoman() {
            return this.survey.accountStage === 'BUY_FOR_WOMEN';
        },
        showNav() {
            return this.isUserLogged && this.$route.meta.authenticationRequired === true;
        },
    },
    methods: {
        ...mapActions(['updateUserSurvey']),
        openDictionary() {
            const url = `https://www.braster.eu/media/wysiwyg/slowniki/słownik_wynik_${this.interfaceLanguage}.pdf`;
            window.open(url, 'new', 'height=800,width=600');
        },
        activateBuyForWomanAccount() {
            this.updateUserSurvey({ ...this.user.patient.survey, completionStage: null });
        },
    },
};
</script>

<style lang="scss">
@import '../node_modules/bootstrap/dist/css/bootstrap.css';
@import '../node_modules/vue-googlemaps/dist/vue-googlemaps.css';
@import '../node_modules/element-ui/lib/theme-chalk/index.css';
@import '../node_modules/vue-nav-tabs/dist/vue-tabs.min.css';
@import '../node_modules/v-calendar/lib/v-calendar.min.css';
@import 'assets/styles/global';
@import 'assets/styles/animations';
@import 'assets/styles/pagination';
@import 'assets/styles/button';
@import 'assets/styles/forms';
@import 'assets/styles/colors';
@import 'assets/styles/vuetify-components';
@import 'assets/styles/vuetify-table';
@import 'assets/styles/vuetify-stepper';
@import 'assets/styles/vue-tabs';
@import 'assets/styles/calendar';
@import 'assets/styles/modal';
@import 'assets/styles/datepicker';
@import 'assets/styles/custom-inputs';

.notifications {
    top: 10px !important;
    right: 10px !important;
}

.notification {
    border-radius: 100px !important;
}

body {
    font-family: 'Ek Mukta', sans-serif;
    font-size: 16px;
}

.arabic {
    direction: rtl;
}

hr {
    border-color: $border-color;
}
h1,
h2 {
    font-weight: normal;
}

.app-menu {
    list-style-type: none;
    padding: 0;
}

.app-menu li {
    display: inline-block;
    margin: 0 10px;
}

a {
    color: $link-color;
}

input {
    border-radius: 0;
    border: 1px solid #ccc;
    transition: all 0.3s;
}

input.is-danger,
input.is-danger:focus,
input.is-danger:active {
    border-color: red;
    border-width: 2px;
}

.help.is-danger {
    color: red;
}

label {
    font-size: 14px;
}

/*title*/
.title-content {
    font-size: 30px;
    font-weight: 700;
    margin-top: 0;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ede8e4;

    @media (max-width: 768px) {
        font-size: 22px;
    }
}

.title-content--no-border {
    border: none;
}

/*footer*/
.footer-submenu__title {
    font-family: 'Mukta', sans-serif;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 14px;
    margin: 0 0 25px;
    color: white;
}

/* Absolute Center Spinner */
.loading {
    position: fixed;
    z-index: 999;
    height: 2em;
    width: 2em;
    overflow: show;
    margin: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
}

/* Transparent Overlay */
.loading:before {
    content: '';
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.75);
}

/* :not(:required) hides these rules from IE9 and below */
.loading:not(:required) {
    /* hide "loading..." text */
    font: 0/0 a;
    color: transparent;
    text-shadow: none;
    background-color: transparent;
    border: 0;
}

.loading:not(:required):after {
    content: '';
    display: block;
    font-size: 25px;
    width: 1em;
    height: 1em;
    margin-top: -0.5em;
    -webkit-animation: spinner 1500ms infinite linear;
    -moz-animation: spinner 1500ms infinite linear;
    -ms-animation: spinner 1500ms infinite linear;
    -o-animation: spinner 1500ms infinite linear;
    animation: spinner 1500ms infinite linear;
    border-radius: 0.5em;
    -webkit-box-shadow: rgba(207, 7, 74, 0.75) 1.5em 0 0 0, rgba(207, 7, 74, 0.75) 1.1em 1.1em 0 0,
        rgba(207, 7, 74, 0.75) 0 1.5em 0 0, rgba(207, 7, 74, 0.75) -1.1em 1.1em 0 0, rgba(207, 7, 74, 0.75) -1.5em 0 0 0,
        rgba(207, 7, 74, 0.75) -1.1em -1.1em 0 0, rgba(207, 7, 74, 0.75) 0 -1.5em 0 0,
        rgba(207, 7, 74, 0.75) 1.1em -1.1em 0 0;
    box-shadow: rgba(207, 7, 74, 0.75) 1.5em 0 0 0, rgba(207, 7, 74, 0.75) 1.1em 1.1em 0 0,
        rgba(207, 7, 74, 0.75) 0 1.5em 0 0, rgba(207, 7, 74, 0.75) -1.1em 1.1em 0 0, rgba(207, 7, 74, 0.75) -1.5em 0 0 0,
        rgba(207, 7, 74, 0.75) -1.1em -1.1em 0 0, rgba(207, 7, 74, 0.75) 0 -1.5em 0 0,
        rgba(207, 7, 74, 0.75) 1.1em -1.1em 0 0;
}

/* Animation */

@-webkit-keyframes spinner {
    0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}
@-moz-keyframes spinner {
    0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}
@-o-keyframes spinner {
    0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}
@keyframes spinner {
    0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}

.rotate-phone {
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;

    background-color: rgba(255, 255, 255, 0.95);
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: none !important;
    z-index: 1;
}

.rotate-phone__text {
    font-size: 1.875rem;
    text-align: center;
    line-height: 1.875rem;
    font-weight: 700;
    color: #333333;
    padding-top: 6.25rem;
    position: relative;
}

.rotate-phone__text:before {
    width: 4.375rem;
    height: 4.375rem;
    content: '';
    position: absolute;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translate(-50%);
    top: 0;
    background: url('./assets/images/rotate.svg') no-repeat;
    background-size: cover;
    background-position: center;
}

.rotate-phone {
    display: -webkit-box !important;
    display: -ms-flexbox !important;
    display: flex !important;
}

td.text-xs-center {
    display: none;
}

.datatable.table {
    display: none;
}

.pagination {
    display: none;
}

.surveyModal {
    display: none;
}

@media screen and (orientation: landscape) {
    .rotate-phone {
        display: none !important;
    }

    td.text-xs-center {
        display: table-cell;
    }

    .datatable.table {
        display: table;
    }

    .pagination {
        display: block;
        text-align: center;
    }

    .surveyModal {
        display: block;
    }
}

.directional-number-custom > .el-input > .el-input__inner {
    border: 1px solid #ccc;
    border-radius: 35px;
}

.unlock-request-modal > .modal-content {
    background-color: white;
}

.tab--last {
    border: none !important;
    border-image: initial !important;
    background-color: white !important;
    position: relative !important;
}

.tab--last--href:hover {
    background-color: white !important;
}

.tab--last--href {
    white-space: initial;
    color: #cf004a !important;
    font-weight: 700 !important;
    padding: 0 0 0 0 !important;
}

.document-type > .el-input > .el-input__inner {
    height: 50px !important;
}

.footer-menu__item {
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 15px;
    position: relative;
    padding-left: 0.812rem;
}

.footer-menu__item--first {
    font-size: 0.875rem;
    font-weight: 800;
    color: #fff;
    text-transform: uppercase;
    margin-bottom: 0.937rem;
}

.footer-menu__item:before {
    content: '';
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    left: 0;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 2.2px 0 2.2px 3.2px;
    border-color: transparent transparent transparent rgba(255, 255, 255, 0.4);
}

.footer-menu__link {
    color: #fff;
    font-weight: 400;
}

.footer-menu__link:hover {
    text-decoration: underline;
}

.footer-menu-div {
    display: flex;
    justify-content: space-between;
}

.footer-menu-div {
    column-count: 1;
}

.footer-menu {
    list-style: none;
    margin-left: 6px;
}

.help-line__column {
    list-style: none;
    padding-left: 50px;
}

@media only screen and (max-width: 767px) {
    .footer-menu-div {
        width: 100%;
        margin-bottom: 1.25rem;
        display: none;
    }
}
</style>



// WEBPACK FOOTER //
// App.vue?4f456f42